<template>
  <div>
  <router-view></router-view>
  <div class="accomodation-info">
    <Modal v-if="showModal()">
      <router-view></router-view>
    </Modal>

    <Timeline :steps="timelineSteps"></Timeline>

    <div class="left-col default-image" :style="(unit && (unit.image || (unit.pool && unit.pool.image) ) ) ? 'background-image:url(' + (unit && (unit.image || (unit.pool && unit.pool.image) ) ) + ')' : 'background-size: cover;'">
    </div>

    <div class="right-col">

      <AccomodationPeriodConfirm @gotprice="setExternalSuccess" :unit="unit" :arrival="arrival" :departure="departure"></AccomodationPeriodConfirm>

      <div style="clear:both;"></div>

      <h1>
        {{(unit.display_name || unit.description_title)}}
        <i v-if="unit.subtitle">{{unit.subtitle}}</i>
      </h1>

      <div class="description" v-html="unit.description_short || unit.description_longer"></div>

      <div class="booking-box">
        <h2>Välj antal resenärer</h2>
        <p>För att göra bokningen enklare behöver du fylla i antalet resenärer.
        <div style="padding-right:4px;" v-if="SITE_CONFIG.skipass.ages.adults">
          <b>Vuxen <span>({{SITE_CONFIG.skipass.ages.adults}} år):</span></b>
          <CounterButton class="counter-button small" :inline="true" :count="adults" :min="0" @changedCount="changeAdults($event)" suffix="st" />
          <div style="clear:both;"></div>
        </div>
        <div style="padding-right:4px;" v-if="SITE_CONFIG.skipass.ages.youths">
          <b>Ungdom <span>({{SITE_CONFIG.skipass.ages.youths}} år):</span></b>
          <CounterButton class="counter-button small" :inline="true" :count="youths" :min="0" @changedCount="changeYouths($event)" suffix="st" />
          <div style="clear:both;"></div>
        </div>
        <div style="padding-right:4px;" v-if="SITE_CONFIG.skipass.ages.seniors">
          <b>Senior <span>({{SITE_CONFIG.skipass.ages.seniors}} år):</span></b>
          <CounterButton class="counter-button small" :inline="true" :count="seniors" :min="0" @changedCount="changeSeniors($event)" suffix="st" />
          <div style="clear:both;"></div>
        </div>
        <div style="padding-right:4px;" v-if="SITE_CONFIG.skipass.ages.children">
          <b>Barn <span>({{SITE_CONFIG.skipass.ages.children}} år):</span></b>
          <CounterButton class="counter-button small" :inline="true" :count="children" :min="0" @changedCount="changeChildren($event)" suffix="st" />
          <div style="clear:both;"></div>
        </div>


      </div>

      <button @click="addToCart" :class="{disabled: !validated()}">{{cartAccomodationObject.confirmed ? 'Spara' : 'Lägg till i varukorg'}} <icon v-if="!cartAccomodationObject.confirmed" name="cart-white" :scale="1.5" /></button>

    </div>

    <div style="clear:both;"></div>

  </div>
  </div>
</template>

<script>
import API from '@/classes/API';
import Modal from '@/components/components/Modal';
import Timeline from '@/components/components/Timeline';
import CounterButton from '@/components/components/CounterButton';
import AccomodationPeriodConfirm from '@/components/parts/Accomodation/AccomodationPeriodConfirm';
import { mapMutations, mapGetters } from 'vuex';
import moment from 'moment';

import accomodationIndex from '@/mixins/accomodationIndex';
import accomodationTimelineSteps from '@/mixins/accomodationTimelineSteps';

import OutlineButton from '@/components/components/OutlineButton';

export default {
  components: {
    Modal,
    Timeline,
    CounterButton,
    OutlineButton,
    AccomodationPeriodConfirm,
  },
  mixins: [accomodationIndex, accomodationTimelineSteps],
  data() {
    return {
      unit: {},
      adults: 0,
      seniors: 0,
      youths: 0,
      children: 0,
      cartObject: {},
      externalCheck: false,
    };
  },
  async beforeMount() {
    this.adults = this.cartAccomodationObject.adults;
    this.seniors = this.cartAccomodationObject.seniors || 0;
    this.youths = this.cartAccomodationObject.youths;
    this.children = this.cartAccomodationObject.children;

    this.$nextTick(async () => {
      const { data } = await API.get(`/units/${this.poolLid}/${this.unitLid}/info`);
      this.unit = data;

      window.trackViewItem({
        title: this.unit.description_title,
        lines: [{
          id: this.unit.unit_code || this.unit.name_corrected,
          title: this.unit.description_title,
          category: 'accomodation',
          category2: (this.unit && this.unit.pool) ? this.unit.pool.name : '',
          quantity: 1,
          price: this.cartAccomodationObject.price,
        }],
      });
    });
  },
  computed: {
    ...mapGetters([
      'cart',
    ]),
    noOfVisitors() {
      return this.adults + this.seniors + this.youths + this.children;
    },
    cartAccomodationObject() {
      if (this.cart.accomodations[this.accomodationIndex]) {
        return this.cart.accomodations[this.accomodationIndex];
      }
      return {};
    },
    poolLid() {
      return this.cartAccomodationObject.poolLid;
    },
    unitLid() {
      return this.cartAccomodationObject.unitLid;
    },
    arrival() {
      if (this.cartAccomodationObject && this.cartAccomodationObject.period) {
        return this.cartAccomodationObject.period.date_arrival;
      }
      return moment(this.$store.state.accomodationsFilter.date.startDate).format('YYYY-MM-DD');
    },
    departure() {
      if (this.cartAccomodationObject && this.cartAccomodationObject.period) {
        return this.cartAccomodationObject.period.date_departure;
      }
      return moment(this.$store.state.accomodationsFilter.date.endDate).format('YYYY-MM-DD');
    },
  },
  methods: {
    ...mapMutations([
      'confirmAccomodation',
      'openModal',
      'closeModal',
      'saveCartLocking',
    ]),
    setExternalSuccess(period) {
      this.externalCheck = period.available;
    },
    showModal() {
      return this.$route.params.pool;
    },
    noOfDays() {
      if (this.cartAccomodationObject && this.cartAccomodationObject.period) {
        const a = moment(this.cartAccomodationObject.period.date_arrival);
        const b = moment(this.cartAccomodationObject.period.date_departure);
        return b.diff(a, 'days') + 1;
      }

      return 0;
    },
    async addToCart() {
      if (this.noOfVisitors <= 0) {
        this.openModal(['GeneralModal', {
          title: 'Välj antal personer',
          content: '<p>För att det ska bli lättare i nästa steg behöver du välja hur många personer i olika åldrar ni är.</p>',
        }]);
        return false;
      }

      const $this = this;
      let url = `/units/${this.unit.pool_lid}/${this.unit.unit_lid}/reserve/${this.arrival}/${this.departure}`;

      if (this.$store.state.lockingCode) {
        url = `${url}/${this.$store.state.lockingCode}`;
      }

      API.get(url).then((result) => {
        if (!result.success) {
          $this.openModal(['GeneralModal', {
            title: 'Bokningstillgänglighet',
            content: `<p>${result.reason}</p>`,
            buttons: [
              {
                title: 'Okej',
                class: '',
                click: () => {
                  $this.closeModal();
                },
              },
            ],
          }]);
          return false;
        }

        this.saveCartLocking({
          code: result.code,
          beforeTime: result.before_time,
        });

        if (this.noOfVisitors > this.cartAccomodationObject.capacity) {
          $this.openModal(['GeneralModal', {
            title: 'Många resenärer',
            content: `<p>Du har valt att ni är totalt ${this.noOfVisitors} personer. Detta boende har kapacitet för ${this.cartAccomodationObject.capacity} personer.</p>`,
            buttons: [
              {
                title: 'Okej, ändra',
                class: 'small',
                click: () => {
                  $this.closeModal();
                },
              },
              // {
              //   title: 'Ändra',
              //   class: 'small white border',
              //   click: () => {
              //     $this.closeModal();
              //   },
              // },
            ],
          }]);
        } else {
          this.moveOn();
        }

        return true;
      });

      return true;
    },
    trackCart() {
      window.trackAddToCart({
        title: this.cartAccomodationObject.description_title,
        lines: [{
          id: this.cartAccomodationObject.unit_code,
          title: this.cartAccomodationObject.description_title,
          category: 'accomodation',
          category2: this.cartAccomodationObject.pool_name || '',
          quantity: 1,
          price: this.cartAccomodationObject.price,
        }],
      });
    },
    moveOn() {
      this.closeModal();

      const confirmed = this.cart.accomodations.filter(a => a.confirmed);
      const datesOkay = (!confirmed.length ||
        (confirmed[0].period.date_arrival === this.cartAccomodationObject.period.date_arrival &&
          confirmed[0].period.date_departure === this.cartAccomodationObject.period.date_departure
        )
      );

      if (!datesOkay) {
        const $this = this;
        this.openModal(['GeneralModal', {
          content: 'Du är på väg att boka ett andra boende. Detta måste bokas under samma period som ditt första.',
          buttons: [{
            title: 'Okej, låt mig ändra datum',
            click: () => {
              $this.trackCart();
              $this.$router.push({
                path: `/boenden/bekrafta/pris/${this.unit.slug}?flow=boenden%2Fbekrafta`,
              });
              $this.closeModal();
            },
            class: 'small',
          }, {
            title: 'Gå till varukorgen',
            click: () => {
              $this.$router.push({ name: 'shopping cart' });
              $this.closeModal();
            },
            class: 'small white border',
          }],
        }]);

        return false;
      }

      this.confirmAccomodation({
        index: this.accomodationIndex,
        adults: this.adults,
        seniors: this.seniors,
        youths: this.youths,
        children: this.children,
        days: this.noOfDays(),
      });

      this.trackCart();

      this.$router.push({ name: 'addons', query: { no: this.accomodationIndex } });
      return true;
    },
    changeAdults(value) {
      this.adults = value;
    },
    changeSeniors(value) {
      this.seniors = value;
    },
    changeYouths(value) {
      this.youths = value;
    },
    changeChildren(value) {
      this.children = value;
    },
    validated() {
      return this.externalCheck && this.noOfVisitors;
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'


.counter-button
  margin-top -5px
  margin-bottom 5px

.accomodation-info
  max-width 1400px
  margin 0 auto
  padding: 10px 0





.left-col
  width 55%
  float left
  background-position right top
  background-size cover
  padding-top 45%
  background-repeat: no-repeat
  background-size cover
  background-position: center;
  +max-tablet()
    padding-top 300px
    width 100%
    float none
    margin-bottom: 10px
  +max-mobile()
    padding-top 180px


.right-col
  width 40%
  float right
  +max-tablet()
    width 100%
    padding-top 10px
    padding-left padding-mobile
    padding-right padding-mobile
    float none

h1
  font-size 24px
  font-weight 900
  letter-spacing 0.3px
  color #1c1c1c
  text-align left
  margin-top 25px
  margin-bottom: 5px
  i
    font-style normal
    font-weight normal
    display block
    color greyish-brown
    margin-top 4px
    font-size 15px
    line-height 1em
    font-family Interstate
    letter-spacing 0em
    text-transform none
    margin-bottom 20px

.description
  font-size 15px
  font-weight 300
  line-height 1.47
  color greyish-brown
  margin-top 8px

.booking-box
  border-radius 4px
  background-color rgb(238, 244, 246)
  background-color rgba(238, 244, 246, 0.6)
  padding 14px 21px
  border solid 1px light-blue-grey
  margin-bottom 38px
  float left
  margin-top 15px
  +max-tablet()
    margin-bottom: 15px
    padding 14px 14px
  p
    font-size: 12px
    position relative
    top -4px


  h2
    font-family  "UnitedSerifCond Heavy"
    font-size 18px
    font-weight 900
    letter-spacing 0.6px
    color #1c1c1c
    margin-bottom 10px
    text-transform uppercase
  & > div
    width 50%
    float left
    display inline-block
    margin-bottom 8px
    margin-top: 8px
    +max-tablet()
      width 50%
      float left
    +max-mobile()
      width 100%
      float left
    +min-xl-tablet()
      width 100%
      float left
    +min-desktop()
      width: 50%
    b
      text-transform uppercase
      span
        font-weight 400
    & > *
      width 50%
      float left
      display inline-block

button
  width 100%
</style>



// WEBPACK FOOTER //
// AccomodationsConfirm.vue?1d54fc40